import { MediaImageStandard, Typography, LinkButton } from 'components/Contentful'
import { Grid } from '@achieve/ascend'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { isExternal } from 'utils/conversions'
import { mainProductConfig } from 'services/contentful/helpers'
import { useContext } from 'react'
import { LayoutContext } from 'providers/LayoutProvider'
import classNames from 'classnames'

export const CardCTA = ({ content, variant, trackingName }) => {
  const { link, title, subtitle, image } = content
  const currentURL = useCurrentUrl()
  const { state: { siteEnv } = {} } = useContext(LayoutContext)

  const isWidget = variant === 'widget'

  return (
    <div className="w-full">
      <Grid
        className={classNames(
          isWidget
            ? 'rounded-[10px] bg-blue-50'
            : 'my-16 p-8 bg-blue-50 rounded-[10px]'
        )}
      >
        <Grid className={classNames(isWidget ? 'mt-2' : '', 'flex')}>
          {image && (
            <div
              className={classNames(
                'p-4 rounded-[10px]',
                isWidget && 'w-[264px] h-[264px]'
              )}
            >
              <MediaImageStandard
                className={classNames('rounded-[10px]', isWidget && 'w-[264px] h-[264px]')}
                alt={image.fields.mediaAltText}
                content={image.fields.mediaContent}
                data-testid="cta-card-main-image"
                objectFit="cover"
              />
            </div>
          )}
          <Grid
            className={classNames(
              'flex',
              isWidget ? 'p-6 flex-col text-center' : 'flex-col text-center'
            )}
          >
            <Typography
              className={classNames(
                '!font-medium lg:!font-bold',
                isWidget ? 'headingMd' : 'headingMd lg:displayMd'
              )}
              content={title}
            />
            {subtitle && (
              <Typography
                className={classNames(
                  'mt-4',
                  isWidget ? 'bodySm' : 'displayMd'
                )}
                content={subtitle}
              />
            )}
            <LinkButton
              track={{
                list_name: 'CTA CARD',
                click_position: '0',
                track_event: 'page_nav_click',
                event_action: 'button_click',
                event_type: 'button_click',
                click_id: link?.linkText?.json?.content[0]?.content[0]?.value,
                click_text: `${mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']} | ${
                  link?.linkText?.json?.content[0]?.content[0]?.value
                }`,
                nav_link_section: `CTA Card - ${trackingName}`,
                click_type:
                  isExternal(link?.fields?.linkHref, currentURL) ||
                  link?.fields?.linkHref?.includes('get-started')
                    ? 'internal_campaign_click'
                    : 'page_nav_click',
              }}
              className={classNames(
                'mt-4',
                isWidget ? 'mb-8' : 'mt-8',
                'cta-button'
              )}
              content={link}
              data-testid="cta-card-button"
              {...(variant && {
                variant: isWidget ? 'outlined' : 'primary',
                color: isWidget ? 'primary' : 'secondary',
              })}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
